import React, { useState } from "react";
import { SpoilerBlock } from "./styled";
import { Text } from "../../../styled";
import arrowIcon from "./../../../resources/images/icons/arrow_icon_white.svg";
import { greyTextColor, lightSecondColor } from "../../../constants/colors";

const Spoiler = (props) => {
  const { spoilerData, remoteConfig, style, isOpen } = props;

  const [isSpoilerOpen, setSpoilerOpen] = useState(isOpen);

  const handleIconClick = () => {
    setSpoilerOpen(() => !isSpoilerOpen);
  };

  return (
    <SpoilerBlock style={style} className={isSpoilerOpen ? "open" : null}>
      <SpoilerBlock.Top>
        <SpoilerBlock.Title className={isSpoilerOpen ? "open" : null}>
          <Text.Fourth
            style={{
              textAlign: "left",
              color: lightSecondColor,
            }}
          >
            {spoilerData.title}
          </Text.Fourth>
        </SpoilerBlock.Title>
        <SpoilerBlock.Icon
          onClick={handleIconClick}
          className={isSpoilerOpen ? "open" : null}
        >
          <img src={arrowIcon} alt="arrow" />
        </SpoilerBlock.Icon>
      </SpoilerBlock.Top>
      <SpoilerBlock.Line />
      <SpoilerBlock.Bottom>
        {spoilerData.dependingKey ? (
          <Text.Fourth style={{ textAlign: "left", color: greyTextColor }}>
            {remoteConfig[spoilerData.dependingKey]
              ? spoilerData.dependText[0]
              : spoilerData.dependText[1]}
          </Text.Fourth>
        ) : (
          spoilerData.text.map((text, index) => {
            return (
              <Text.Fourth
                style={{
                  textAlign: "left",
                  color: greyTextColor,
                  marginBottom: index !== spoilerData.text.length - 1 ? 10 : 0,
                }}
                key={`${index}-spoiler-text`}
              >
                {text}
              </Text.Fourth>
            );
          })
        )}
        {spoilerData.science ? (
          <Text.Eight
            style={{
              textTransform: "none",
              color: greyTextColor,
              fontStyle: "italic",
              letterSpacing: 0,
              textAlign: "left",
              marginTop: 10,
            }}
          >
            {spoilerData.science}
          </Text.Eight>
        ) : null}
      </SpoilerBlock.Bottom>
    </SpoilerBlock>
  );
};

export default Spoiler;
